<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { accidentInfo } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div v-if="accidentInfo.display" class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ accidentInfo.title }}
      </template>

      <template #content>
        <p>{{ accidentInfo.desc }}</p>
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
